import { APIModel } from "./api-model";
import { AssociatedUser } from "./associated-user";

export class Assignment extends APIModel {
  id!: string;
  assigned_to!: AssociatedUser;

  static fieldsToMap = {
    direct: [
      'id',
      'assigned_to'
    ]
  }

  static buildFromAPI(record: any): Assignment {
    const row = new Assignment();
    record = record || {};

    this.mapFieldsDirectly<Assignment>(Assignment.fieldsToMap.direct, record, row);
    if(record.assigned_to) row.assigned_to = AssociatedUser.buildFromAPI(record.assigned_to);


    return row;
  }
}